const GlobalData: any = {}
export default GlobalData;